export interface IConfig{
    proxy: string;
    sp: any;
    graph: any;
    environment: SPEnvironment;
    mockUser: string;
}

export enum SPEnvironment{
    dev="dev",
    local="local",
    prod="prod",
    pre="pre"
}